import header from "./mann-haelt-bebauungsplan.jpg";
import section1 from "./bebauungsplan-wird-besprochen.jpg";
import section2 from "./bebauungsplan-mit-lupe.webp";
import section3 from "./bebauungsplan.webp";
import section4 from "./bebauungsplan-gebiet.jpg";
import section5 from "./bebauungsplan-auf-papier.jpg";
import section6 from "./verschiedene-bebauungsplaene.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
